import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerTempTransportDetailsRequest extends BaseUpdateRequest {
    isDriver: boolean;
    maximumPassengers: number;
}